import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-12 rounded-3" }
const _hoisted_3 = {
  key: 0,
  class: "text-center py-5"
}
const _hoisted_4 = { class: "alert alert-warning text-uppercase fw-bold" }
const _hoisted_5 = {
  key: 1,
  class: "text-center py-5"
}
const _hoisted_6 = { class: "alert alert-danger text-uppercase fw-bold" }
const _hoisted_7 = {
  key: 2,
  class: "text-center py-5"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-success",
  role: "status"
}, null, -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = {
  key: 3,
  class: "text-center"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h5", { class: "text-uppercase fw-bold" }, "Beneficio agotado", -1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = {
  key: 4,
  class: "text-center"
}
const _hoisted_14 = { class: "text-uppercase fw-bold mb-3" }
const _hoisted_15 = {
  key: 0,
  class: "row align-items-center gy-4 gx-5"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-8 mb-4 mb-md-0 text-center text-md-start h-100 d-flex flex-column justify-content-between" }, [
  /*#__PURE__*/_createElementVNode("h2", {
    class: "text-uppercase fw-bold mb-8",
    style: {"padding-bottom":"20%"}
  }, " Utiliza este código de promoción en tu próxima compra "),
  /*#__PURE__*/_createElementVNode("p", { class: "small text-muted mb-0 align-self-end" }, " CÓDIGO DE UNICO USO. PARA SER ESCANEADO UNICAMENTE POR PERSONAL DEL LOCAL AL MOMENTO DEL CANJE. ")
], -1)
const _hoisted_17 = { class: "col-md-4 text-center d-flex justify-content-end align-items-center min-vh-25" }
const _hoisted_18 = ["src"]
const _hoisted_19 = {
  key: 1,
  class: "text-center py-5"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "text-danger fw-bold" }, "No hay QR disponible", -1)
const _hoisted_21 = [
  _hoisted_20
]

import { cuponesService } from '@/services/cupones.service'
import { userService } from '@/services/user.service'
import { onMounted, ref } from 'vue'
import { VuexStore } from '@/interfaces/VuexStore'
import { key } from '@/setup/store'
import { useStore } from 'vuex'

interface CuponResponse {
  codigo: string
  store_url: string
  redeemedQR?: string
  actividadRestrictora?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TheCupones',
  props: {
    id: null,
    nombre: null
  },
  setup(__props: any) {

const props = __props as {
  id: number
  nombre: string
};

const { getters } = useStore<VuexStore>(key)



const loading = ref(false)

const cuponesDisponibles = ref(false) 

const cupon = ref()
const url = ref()
const redeemedQR = ref()
const actividadRestrictora = ref<string | undefined>(undefined)
const mensajeCupon = ref<string | undefined>(undefined)


const miCupon = async () => {
  const response = await userService.misCuponPorActividad(props.id)
  if ('reedmed_message' in response) {
    mensajeCupon.value = response.reedmed_message
    cupon.value = undefined
    url.value = undefined
    redeemedQR.value = undefined
    actividadRestrictora.value = undefined
    return
  }
  const {
    codigo,
    store_url,
    redeemedQR: qr,
    actividadRestrictora: restr
  } = response as CuponResponse
  cupon.value = codigo
  url.value = store_url
  redeemedQR.value = qr
  actividadRestrictora.value = restr
  mensajeCupon.value = undefined
}

const hayCuponesDisponibles = async () => {
  cuponesDisponibles.value = await cuponesService.hayCuponesDisponibles(
    props.id
  )
}


const obtenerCupon = async () => {
  loading.value = true
  const {
    codigo,
    store_url,
    redeemedQR: qr,
    actividadRestrictora: restr
  } = await cuponesService.obtenerCupon(props.id) as CuponResponse
  cupon.value = codigo
  url.value = store_url
  redeemedQR.value = qr
  actividadRestrictora.value = restr
  loading.value = false
}

onMounted(async () => {
  loading.value = true
  if (getters.isLogin) {
    await miCupon()
    if (!cupon.value) {
      await hayCuponesDisponibles()
    }
  }
  loading.value = false
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (mensajeCupon.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(mensajeCupon.value), 1)
          ]))
        : (actividadRestrictora.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, " No podés solicitar este beneficio ya que has canjeado con anterioridad " + _toDisplayString(actividadRestrictora.value), 1)
            ]))
          : (loading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9))
            : (!cupon.value && !cuponesDisponibles.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_12))
              : (!cupon.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _createElementVNode("h5", _hoisted_14, " Obtené tu beneficio exclusivo de " + _toDisplayString(props.nombre) + " desde el siguiente botón ", 1),
                    _createElementVNode("button", {
                      class: "btn btn-primary px-4 py-2 text-uppercase",
                      type: "button",
                      onClick: obtenerCupon
                    }, " Quiero mi beneficio ")
                  ]))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                    (redeemedQR.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                          _hoisted_16,
                          _createElementVNode("div", _hoisted_17, [
                            _createElementVNode("img", {
                              src: redeemedQR.value,
                              alt: "QR Code",
                              class: "img-fluid",
                              style: {"max-height":"220px"}
                            }, null, 8, _hoisted_18)
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_19, _hoisted_21))
                  ], 64))
    ])
  ]))
}
}

})